import styles from './ClearButton.module.css';

interface ClearButtonProps {
  onClick: () => void;
  /** Visible text inside the pill (also used as the accessible label). */
  label: string;
  className?: string;
}

/**
 * Reusable "clear this textarea" pill button. Reads as a small chip with an
 * opaque page-background so body text flowing under its absolute position
 * stops visually at its edge. The label is the visible word — rendered as a
 * text chip (not an icon) because users found the × icon ambiguous.
 *
 * Callers own any confirm-before-clearing state; this component is just the
 * trigger.
 */
export default function ClearButton({ onClick, label, className }: ClearButtonProps) {
  return (
    <button
      type="button"
      className={`${styles.clearBtn} ${className ?? ''}`}
      onClick={onClick}
      aria-label={label}
    >
      {label}
    </button>
  );
}
